import { MessageResponse } from "./messageResponse";

export class BeginPensionTransferResponse extends MessageResponse {
    redirectTo: string;
}
